export { default as WorkshopAdmin } from './WorkshopAdmin';
